'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _debug = require('debug');

var _debug2 = _interopRequireDefault(_debug);

var _TimeEngine = require('../core/TimeEngine');

var _TimeEngine2 = _interopRequireDefault(_TimeEngine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = (0, _debug2.default)('wavesjs:masters');

function isFunction(functionToCheck) {
  return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

/**
 *
 *
 *
 * The SimpleScheduler class implements a simplified master for time engines
 * (see TimeEngine) that implement the scheduled interface
 * such as the Metronome and the GranularEngine. The API and funtionalities of
 * the SimpleScheduler class are identical to the Scheduler class. But, other
 * than the Scheduler, the SimpleScheduler class does not guarantee the order
 * of events (i.e. calls to the advanceTime method of scheduled time engines
 * and to scheduled callback functions) within a scheduling period (see period
 * attribute).
 *
 * {@link https://rawgit.com/wavesjs/waves-masters/master/examples/scheduler/index.html}
 *
 * @param {Function} getTimeFunction - Function that must return a time in second.
 * @param {Object} [options={}] - default options
 * @param {Number} [options.period=0.025] - period of the scheduler.
 * @param {Number} [options.lookahead=0.1] - lookahead of the scheduler.
 *
 * @see TimeEngine
 * @see Scheduler
 *
 * @example
 * import * as masters from 'waves-masters';
 *
 * const getTimeFunction = () => preformance.now() / 1000;
 * const scheduler = new masters.SimpleScheduler(getTimeFunction);
 *
 * scheduler.add(myEngine);
 */

var SimpleScheduler = function () {
  function SimpleScheduler(getTimeFunction) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck3.default)(this, SimpleScheduler);

    if (!isFunction(getTimeFunction)) throw new Error('Invalid argument `getTimeFunction`');

    this.getTimeFunction = getTimeFunction;

    this.__engines = new _set2.default();

    this.__schedEngines = [];
    this.__schedTimes = [];

    this.__currentTime = null;
    this.__timeout = null;

    /**
     * scheduler (setTimeout) period
     * @type {Number}
     * @name period
     * @memberof Scheduler
     * @instance
     */
    this.period = options.period || 0.025;

    /**
     * scheduler lookahead time (> period)
     * @type {Number}
     * @name lookahead
     * @memberof Scheduler
     * @instance
     */
    this.lookahead = options.lookahead || 0.1;

    this._currentTimeToAudioTimeFunction = options.currentTimeToAudioTimeFunction || function (currentTime) {
      return currentTime;
    };
  }

  (0, _createClass3.default)(SimpleScheduler, [{
    key: '__scheduleEngine',
    value: function __scheduleEngine(engine, time) {
      this.__schedEngines.push(engine);
      this.__schedTimes.push(time);
    }
  }, {
    key: '__rescheduleEngine',
    value: function __rescheduleEngine(engine, time) {
      var index = this.__schedEngines.indexOf(engine);

      if (index >= 0) {
        if (time !== Infinity) {
          this.__schedTimes[index] = time;
        } else {
          this.__schedEngines.splice(index, 1);
          this.__schedTimes.splice(index, 1);
        }
      } else if (time < Infinity) {
        this.__schedEngines.push(engine);
        this.__schedTimes.push(time);
      }
    }
  }, {
    key: '__unscheduleEngine',
    value: function __unscheduleEngine(engine) {
      var index = this.__schedEngines.indexOf(engine);

      if (index >= 0) {
        this.__schedEngines.splice(index, 1);
        this.__schedTimes.splice(index, 1);
      }
    }
  }, {
    key: '__resetTick',
    value: function __resetTick() {
      if (this.__schedEngines.length > 0) {
        if (!this.__timeout) {
          log('SimpleScheduler Start');
          this.__tick();
        }
      } else if (this.__timeout) {
        log('SimpleScheduler Stop');
        clearTimeout(this.__timeout);
        this.__timeout = null;
      }
    }
  }, {
    key: '__tick',
    value: function __tick() {
      var _this = this;

      var currentTime = this.getTimeFunction();
      var i = 0;

      while (i < this.__schedEngines.length) {
        var engine = this.__schedEngines[i];
        var time = this.__schedTimes[i];

        while (time && time <= currentTime + this.lookahead) {
          time = Math.max(time, currentTime);
          this.__currentTime = time;
          time = engine.advanceTime(time);
        }

        if (time && time < Infinity) {
          this.__schedTimes[i++] = time;
        } else {
          this.__unscheduleEngine(engine);

          // remove engine from scheduler
          if (!time) {
            engine.master = null;
            this.__engines.delete(engine);
          }
        }
      }

      this.__currentTime = null;
      this.__timeout = null;

      if (this.__schedEngines.length > 0) {
        this.__timeout = setTimeout(function () {
          _this.__tick();
        }, this.period * 1000);
      }
    }

    /**
     * Scheduler current logical time.
     *
     * @name currentTime
     * @type {Number}
     * @memberof Scheduler
     * @instance
     */

  }, {
    key: 'defer',


    // call a function at a given time
    /**
     * Defer the execution of a function at a given time.
     *
     * @param {Function} fun - Function to defer
     * @param {Number} [time=this.currentTime] - Schedule time
     */
    value: function defer(fun) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentTime;

      if (!(fun instanceof Function)) throw new Error("object cannot be defered by scheduler");

      this.add({
        advanceTime: function advanceTime(time) {
          fun(time);
        } // make sur that the advanceTime method does not returm anything
      }, time);
    }

    /**
     * Add a TimeEngine function to the scheduler at an optionally given time.
     *
     * @param {TimeEngine} engine - Engine to add to the scheduler
     * @param {Number} [time=this.currentTime] - Schedule time
     */

  }, {
    key: 'add',
    value: function add(engine) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentTime;

      if (!_TimeEngine2.default.implementsScheduled(engine)) throw new Error("object cannot be added to scheduler");

      if (engine.master) throw new Error("object has already been added to a master");

      // set master and add to array
      engine.master = this;
      this.__engines.add(engine);

      // schedule engine
      this.__scheduleEngine(engine, time);
      this.__resetTick();
    }

    /**
     * Remove a TimeEngine from the scheduler that has been added to the
     * scheduler using the add method.
     *
     * @param {TimeEngine} engine - Engine to remove from the scheduler
     * @param {Number} [time=this.currentTime] - Schedule time
     */

  }, {
    key: 'remove',
    value: function remove(engine) {
      if (!engine.master || engine.master !== this) throw new Error("engine has not been added to this scheduler");

      // reset master and remove from array
      engine.master = null;
      this.__engines.delete(engine);

      // unschedule engine
      this.__unscheduleEngine(engine);
      this.__resetTick();
    }

    /**
     * Reschedule a scheduled time engine at a given time.
     *
     * @param {TimeEngine} engine - Engine to reschedule
     * @param {Number} time - Schedule time
     */

  }, {
    key: 'resetEngineTime',
    value: function resetEngineTime(engine) {
      var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.currentTime;

      this.__rescheduleEngine(engine, time);
      this.__resetTick();
    }

    /**
     * Check whether a given engine is scheduled.
     *
     * @param {TimeEngine} engine - Engine to check
     */

  }, {
    key: 'has',
    value: function has(engine) {
      return this.__engines.has(engine);
    }

    /**
     * Remove all engines from the scheduler.
     */

  }, {
    key: 'clear',
    value: function clear() {
      if (this.__timeout) {
        clearTimeout(this.__timeout);
        this.__timeout = null;
      }

      this.__schedEngines.length = 0;
      this.__schedTimes.length = 0;
    }
  }, {
    key: 'currentTime',
    get: function get() {
      return this.__currentTime || this.getTimeFunction() + this.lookahead;
    }

    /**
     * Scheduler current audio time according to `currentTime`
     *
     * @name audioTime
     * @type {Number}
     * @memberif Scheduler
     * @instance
     */

  }, {
    key: 'audioTime',
    get: function get() {
      // @note - add this as in
      if (this.master) return this.master.audioTime;

      return this._currentTimeToAudioTimeFunction(this.currentTime);
    }
  }, {
    key: 'currentPosition',
    get: function get() {
      return undefined;
    }
  }]);
  return SimpleScheduler;
}();

exports.default = SimpleScheduler;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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